import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 20.36c0 1.087-1.293 1.656-2.095.921l-4.875-4.47a.25.25 0 0 0-.169-.065H4a1.75 1.75 0 0 1-1.75-1.75v-6c0-.967.784-1.75 1.75-1.75h2.611a.25.25 0 0 0 .17-.066l4.874-4.47c.802-.734 2.095-.165 2.095.923zm-10-5.364c0 .138.112.25.25.25h2.611c.438 0 .86.164 1.183.46l4.456 4.084V4.2L7.794 8.287c-.323.296-.745.46-1.183.46H4a.25.25 0 0 0-.25.25zM17.25 11.996c0-1.104-.55-2.08-1.393-2.668a.75.75 0 0 1 .857-1.23 4.75 4.75 0 0 1 2.036 3.898 4.75 4.75 0 0 1-2.036 3.898.75.75 0 1 1-.857-1.23 3.25 3.25 0 0 0 1.393-2.668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.251 11.996c0-1.95-.892-3.69-2.293-4.838a.75.75 0 0 1 .951-1.16 7.74 7.74 0 0 1 2.842 5.998 7.74 7.74 0 0 1-2.842 5.997.75.75 0 0 1-.951-1.16 6.24 6.24 0 0 0 2.293-4.837"
  }));
}
var IcVolumeon = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeon));

export { IcVolumeon as I };
